export default "__VITE_ASSET__686065b6__"